import { createAction } from '../../../../store.model';
import { Item } from '../../core';
import { ActionType } from '../event-centre-dialog.action';
import { FilterOptions } from '../model/filter-options.model';

export interface FilterItems {
    opts?: FilterOptions;
}

export const filterItems = createAction<ActionType, FilterItems>(
    ActionType.NOTI__EC__FILTER_ITEMS,
);

export interface FilterItemsResult extends FilterItems {
    items?: Item[];
}

export const filterItemsResult = createAction<ActionType, FilterItemsResult>(
    ActionType.NOTI__EC__FILTER_ITEMS_RESULT,
);
